import { Center, ClampMargins } from "@pdfking/math"
import { ZERO_DISTANCE } from "@pdfking/math/constants"

import type { Drawable } from "#internal"

import { CreateGroup } from "../../../shapes/CreateGroup"
import { CreateMedia } from "../../../shapes/CreateMedia"
import { OwnBox } from "../layout/OwnBox"

/**
 * The page's media, authored upright and turned onto where the page landed.
 * The bleed the layout gave the page, capped at the form's, is the mask: what shows beyond the
 * page's own box. One media per destination printing the page; an unprinted
 * page draws none.
 *
 * The turn pivots on the page's own box, not on the box plus its mask — a
 * lopsided mask would otherwise walk the page off its cell.
 */
export const DrawGrowFile: Drawable = (node, _frame, ctx) => {
  const page = node.page
  if (!page) return []
  const box = OwnBox(page)
  const number = ctx.page_number_of(page.guid)
  const mask = ClampMargins(page.bleed, ZERO_DISTANCE, ctx.bleed)
  const media = number ? ctx.media_of(number) : []
  return CreateGroup(
    media.flatMap(slot => [...ctx.media_processor(CreateMedia(box, { mask, ...slot }))]),
    {
      origin: Center(box),
      rotation: page.rotation,
    }
  )
}
